// src/constants/campus.ts
// Role names are "ActsCareCampus" + the campus name exactly as the Location is named in the data
// (e.g. "ActsCareCampusGlen Austin"). The part after the prefix is what gets compared to a row's location.
export const CAMPUS_ROLES = [
  'ActsCareCampusGlen Austin', 'ActsCareCampusVorna Valley', 'ActsCareCampusWestdene',
  'ActsCareCampusBradfort', 'ActsCareCampusCapeTown', 'ActsCareCampusSpring',
  'ActsCareCampusSoshanguve', 'ActsCareCampusKinshasa',
  'ActsCareCampusPetermaritzburg', 'ActsCareCampusMagaliesburg',
];

export const CAMPUS_ROLE_PREFIX = 'ActsCareCampus';

/** "ActsCareCampusGlen Austin" -> "Glen Austin" */
export const campusSlug = (role: string) => role.slice(CAMPUS_ROLE_PREFIX.length);

/** "ActsCareCampusCapeTown" -> "Cape Town" (menu label) */
export const campusName = (role: string) =>
  campusSlug(role).replace(/([a-z])([A-Z])/g, '$1 $2');

/** "Glen Austin" -> "ActsCareCampusGlen Austin" */
export const roleFromSlug = (slug: string) => `${CAMPUS_ROLE_PREFIX}${slug}`;

/** Ignore case and spaces so "CapeTown", "Cape Town" and "cape town" are the same campus. */
const normalise = (s: string) => s.replace(/\s+/g, '').toLowerCase();

/**
 * Does a row's location belong to this campus?
 * Starts-with, so a location called "Glen Austin Campus" still matches the campus "Glen Austin".
 * A row with no location matches nothing, so it is never shown on a campus page.
 */
export const matchesCampus = (campus: string, locationName?: string | null) =>
  !!locationName && normalise(locationName).startsWith(normalise(campus));
